import React, { useState } from 'react'

import Placeholder from '../Placeholder'
import Stack from '../Stack'
import Typography from '../Typography'

import Brandy from '../Brandy'
import Form from '../Form'
import Dots from './Dots'
import LoadingStep from './LoadingStep'
import Step from './Step'

import * as Styled from './MegaForm.styles'

const MegaForm = ({
  formId,
  onSubmit,
  stepsData,
  addressQualificationCode = null,
  children = null,
  disclaimer = null,
  fields = null,
  formDisclaimerPosition = 'Below Submit Button',
  formName = null,
  heading = null,
  subheading = null,
  isInsideModal = false,
  loadingDelayPerItem: loadingDelayPerItemProp = null,
  megaFormDisclaimer = null,
  smartyStreetsWebsiteKey = null,
  spanish = false,
  submissionData = {},
  submissionMessage = null,
  submitButtonText = 'Submit',
  tcpaCheckbox = false,
}) => {
  const [isLastStep, setIsLastStep] = useState(false)
  const [currentStep, setCurrentStep] = useState(1)
  const [activeDot, setActiveDot] = useState(1)
  const [loadingStepValues, setLoadingStepValues] = useState({})

  // Taken from the cuttlefish implementation, this allows us to not
  // require the form to have an email_address field on the last step
  const [stepValues, setStepValues] = useState()

  if (!stepsData?.[formId])
    return (
      <Placeholder type="error">
        <Typography variant="small">Error:</Typography>
        <Typography>formId {formId} not found</Typography>
        <br />
        <Typography>
          Double check that the correct formId is used as a key in the
          StepsData.jsx file
        </Typography>
      </Placeholder>
    )

  // The number of navigation dots to render and the step data for the given guid in StepsData.jsx
  const { numberOfDots, loadingDelayPerItem, steps } = stepsData[formId]

  // This allows us to pass in the delay amount per item as a prop but also pass the value from
  // StepsData.jsx if a user only wants to shadow that file to adjust this value
  const delay = loadingDelayPerItemProp || loadingDelayPerItem

  // Title and options for the current step
  // [currentStep - 1] because steps is an array which is 0 indexed
  const { title, options } = steps[currentStep - 1]

  return (
    <Styled.MegaFormWrapper
      isInsideModal={isInsideModal}
      className={`leshen-mega-form-wrapper ${
        isInsideModal ? 'is-inside-modal' : ''
      }`}
    >
      <Stack className="stack" spacing="lg">
        <Styled.MegaForm className="leshen-mega-form">
          <Styled.Heading className="heading" variant="h3">
            {heading}
          </Styled.Heading>
          {megaFormDisclaimer && (
            <Brandy
              text={megaFormDisclaimer?.brandy?.text || megaFormDisclaimer}
            />
          )}
          <Styled.Container className="container">
            {isLastStep ? (
              <LoadingStep
                loadingStepValues={loadingStepValues}
                loadingDelayPerItem={delay}
                className="loading-step"
              >
                <Form
                  formName={formName}
                  fields={fields}
                  submitButtonText={submitButtonText}
                  onSubmit={onSubmit}
                  initialStepValues={stepValues}
                  disclaimer={disclaimer}
                  submissionData={submissionData}
                  customSubmissionMessage={submissionMessage}
                  className="form"
                  smartyStreetsWebsiteKey={smartyStreetsWebsiteKey}
                  addressQualificationCode={addressQualificationCode}
                  spanish={spanish}
                  tcpaCheckbox={tcpaCheckbox}
                  formDisclaimerPosition={formDisclaimerPosition}
                  subheading={subheading}
                />
              </LoadingStep>
            ) : (
              <>
                <Typography className="title" variant="h5">
                  {title}
                </Typography>
                <Styled.StepWrapper className="step-wrapper">
                  <Step
                    className="step"
                    key={title}
                    data={options}
                    setCurrentStep={setCurrentStep}
                    setIsLastStep={setIsLastStep}
                    stepValues={stepValues}
                    setStepValues={setStepValues}
                    activeDot={activeDot}
                    setActiveDot={setActiveDot}
                    loadingStepValues={loadingStepValues}
                    setLoadingStepValues={setLoadingStepValues}
                  />
                </Styled.StepWrapper>
              </>
            )}

            <Dots
              numberOfDots={numberOfDots}
              isLastStep={isLastStep}
              activeDot={activeDot}
              className="dots"
            />
          </Styled.Container>
        </Styled.MegaForm>

        {children}
      </Stack>
    </Styled.MegaFormWrapper>
  )
}

export default MegaForm
